<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Blog</li>
        <li class="breadcrumb-item"><router-link :to="{name: 'blog-records'}">Posts</router-link></li>
        <li class="breadcrumb-item active">{{ record.title }}</li>
      </ol>
    </div>
    <form v-if="$store.state.permissions.edit.blog_posts" action="/api/admin/blog/records/save" method="POST" @submit.prevent="saveRecord()">
      <div class="card">
        <div class="card-body">
          <h3 class="page-title">Edit blog post #{{ record.id }}</h3>
          <div class="form-group">
            <label>Title</label>
            <input
              :class="{ 'is-invalid': $v.record.title.$error }"
              v-model.trim="record.title"
              class="form-control"
              @input="$v.record.title.$touch()"
            >
            <div v-if="$v.record.title.$error">
              <span
                v-if="!$v.record.title.required"
                class="help-block help-block-error"
              >Field is required</span>
              <span
                v-if="!$v.record.title.minLength"
                class="help-block help-block-error"
              >Title must have at least {{ $v.record.title.$params.minLength.min }} letters.</span>
            </div>
          </div>
          <div class="form-group">
            <label>Slug (leave empty for automatic generation)</label>
            <input v-model.trim="record.slug" class="form-control" >
          </div>
          <div class="form-group">
            <label>Date (leave empty for automatic generation)</label>
            <flat-pickr :config="options" v-model="record.created_at" class="form-control" placeholder="Select Date"/>
          </div>
          <div class="form-group">
            <label>Categories</label>
            <multiselect
              v-model="record.categories"
              :options="categories"
              :multiple="true"
              track-by="id"
              label="title"
            />
          </div>
          <div class="form-group">
            <label>Preview image</label>
            <br >
            <img-inputer
              v-model="record.preview"
              :img-src="previewImg"
              exceed-size-text="Size of the file should be less than "
              theme="light"
              size="large"
              accept="image/*"
            />
            <br >
            <button type="button" class="btn btn-danger" @click="record.preview = null">Clear</button>
          </div>
          <div class="form-group">
            <label>Main image</label>
            <br >
            <img-inputer
              v-model="record.main"
              :img-src="mainImg"
              exceed-size-text="Size of the file should be less than "
              theme="light"
              size="large"
              accept="image/*"
            />
            <br >
            <button type="button" class="btn btn-danger" @click="record.main = null">Clear</button>
          </div>
          <div class="form-group">
            <label>Preview Content</label>
            <quill-editor ref="blogPreviewContentEditor" v-model="record.preview_text"/>
          </div>
          <div class="form-group">
            <label>Content</label>
            <quill-editor ref="blogContentEditor" v-model="record.content"/>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <button type="button" class="btn btn-primary" @click="goBack">Back</button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </div>
    </form>
    <div v-else class="card">
      <div class="card-header">
        <h3>You have not permission for do that</h3>
      </div>
    </div>
  </div>
</template>

<script>
/* global axios, toastr */
import { required, minLength } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
export default {
  name: 'BlogRecordsEdit',
  components: { Multiselect },
  data () {
    return {
      record: {},
      categories: [],
      options: {
        allowInput: true,
        dateFormat: 'Y-m-d H:i:S',
        enableTime: true,
        enableSeconds: true
      }
    }
  },
  computed: {
    previewImg: function () {
      if (typeof this.record.preview === 'string') {
        return this.record.preview
      }
      return null
    },
    mainImg: function () {
      if (typeof this.record.main === 'string') {
        return this.record.main
      }
      return null
    }
  },
  validations: {
    record: {
      title: {
        required,
        minLength: minLength(4)
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    let route = '/api/admin/blog/records/' + to.params.recordId
    axios
      .get(route)
      .then(repsonse => {
        next(vm => (vm.record = repsonse.data.record))
      })
      .catch(error => {
        console.log(error)
        next()
      })
  },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  beforeRouteUpdate (to, from, next) {
    console.log('update')
  },
  created () {
    axios
      .get('/api/admin/blog/categories')
      .then(repsonse => {
        this.categories = repsonse.data.categories.map(item => {
          return {
            id: item.id,
            title: item.title
          }
        })
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    saveRecord () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let formData = new FormData()
        for (var key in this.record) {
          if (key === 'categories') {
            let categories = this.record[key].map(item => item.id)
            formData.append(key, categories)
          } else {
            formData.append(key, this.record[key])
          }
        }

        axios
          .post('/api/admin/blog/records/save', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.record = response.data.record
              toastr['success']('Changes have been saved successfully')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
            }
          })
          .catch(error => {
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
      }
    },
    goBack () {
      this.$router.push('/admin/blog/records')
    }
  }
}
</script>

<style>
</style>
